module.exports = __webpack_public_path__ + "static/media/sadSmile.a12abaac.png";